import styled, { css } from "styled-components";
import theme from "../../../Styles/theme";
import {Container} from "../Sections/styles";


export {Container};
export const Section = styled.section`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* margin-top:2vh ; */
`;

interface ContainerInputProps {
  w: number;
}
export const ContainerInput = styled.div<ContainerInputProps>`
  width: ${({ w }) => (w ? `${w}%` : "100%")};
`;

export const Label = styled.label`
  min-width: 100%;
  color: ${theme.colors.dark};
  font-size: max(0,9vw, 8px);
  font-weight: bold;
  padding: 1vh 1.2vw;
`;

export const Input = styled.div`
  width: 100%;
  border: solid 1px ${theme.colors.dark};
  color: ${theme.colors.dark};
  font-size: max(0.9vw, 7px);
  padding: 0.5vh 1.2vw;
  font-weight:bold;
`;
